module.exports = __webpack_public_path__ + "static/hand-drawn-separator-1-d2a8c7dc0d2415ee627a0bb67fcd4cbd.svg";